//* Libraries imports
import { useState } from "react";

//* Service imports
import { techinicalHistoryService } from "@/features/techinicaldocument/TechinicalHistoryService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  TechinicalHistoryOutputDTO,
  TechinicalHistoryPayload,
} from "@/features/techinicaldocument/types";

export const useCreateTechinicalHistory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<TechinicalHistoryOutputDTO | null>(null);

  const create = async (payload: TechinicalHistoryPayload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await techinicalHistoryService.create(payload);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        setData(response.data || null);
        return response.data;
      }

      throw new Error("Resposta inesperada do servidor");
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao criar o histórico técnico";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { create, loading, error, data };
};
